export default {
      id: "arrow-right-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#arrow-right",
      toString: function () {
        return this.url;
      }
    }